import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  status: "attended" | "no_show";
  visitLabel: string;
  isSaving: boolean;
  onConfirm: () => void;
};

export function AttendanceConfirmDialog({
  open,
  onOpenChange,
  status,
  visitLabel,
  isSaving,
  onConfirm,
}: Props): React.JSX.Element {
  const label = status === "attended" ? "asistió" : "no asistió";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Registrar asistencia</DialogTitle>
          <DialogDescription>
            ¿Marcar que el lead <strong>{label}</strong> a la visita del {visitLabel}?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>
            Volver
          </Button>
          <Button size="sm" disabled={isSaving} onClick={onConfirm}>
            {isSaving ? "Guardando…" : `Marcar ${label}`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
